const programs = {
  credito: 'CRÉDITO',
  debito: 'Débito',
  'debito zero-balance': 'Débito',
  'credito zero-balance': 'Crédito',
};

export default programs;
